// extracted by mini-css-extract-plugin
module.exports = {"loaderBackground":"index-module--loaderBackground--2Bobm","loaderImage":"index-module--loaderImage--33tqe","loaderText":"index-module--loaderText--32pi5"};